import { openBlock as r, createElementBlock as l, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, t) {
  return r(), l("svg", o, [...t[0] || (t[0] = [
    e("g", { "clip-path": "url(#a)" }, [
      e("path", {
        fill: "currentColor",
        d: "M8.5 15.6h7v1.8h-7zm0-3.6h7v1.8h-7zm5.25-9h-7C5.787 3 5 3.81 5 4.8v14.4c0 .99.779 1.8 1.741 1.8H17.25c.962 0 1.75-.81 1.75-1.8V8.4zm3.5 16.2H6.75V4.8h6.125v4.5h4.375z"
      })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
